import SVG from './SVG'

export const DoubleQuotes1SVG = (props) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      fill="none"
      viewBox="0 0 13 12"
      {...props}
    >
      <g className="double_quotation_marks_left">
        <path
          fill="#9B9B9B"
          d="M1.632 0c1.056.704 2.256 1.168 3.6 1.392.128.32.224.784.288 1.392.096.608.128 1.136.096 1.584-1.408.096-2.112.88-2.112 2.352 0 .64.176 1.408.528 2.304.384.896.832 1.696 1.344 2.4-.224.16-.528.288-.912.384-.384.096-.704.128-.96.096A15.223 15.223 0 0 1 .912 7.92C.304 6.448 0 5.024 0 3.648 0 1.92.544.704 1.632 0Zm7.104.144c.96.672 2.176 1.136 3.648 1.392.128.32.224.768.288 1.344.096.544.128 1.04.096 1.488-1.472.096-2.208.88-2.208 2.352 0 .608.176 1.344.528 2.208a17.67 17.67 0 0 0 1.344 2.4c-.224.16-.528.288-.912.384-.352.096-.672.128-.96.096-1.088-1.248-1.936-2.56-2.544-3.936-.608-1.376-.912-2.736-.912-4.08 0-1.76.544-2.976 1.632-3.648Z"
          className="quotes1"
        />
      </g>
    </SVG>
  )
}
